/* Progressive enhancement: every question and answer is already in the HTML. */
(() => {
  function init(root) {
    if (!root || root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const search = root.querySelector('.hf-faq__search');
    const input = root.querySelector('input[type="search"]');
    const status = root.querySelector('[role="status"]');
    const groups = [...root.querySelectorAll('.hf-faq__group')];
    const entries = [...root.querySelectorAll('details')];
    const empty = root.querySelector('.hf-faq__empty');
    const normalize = value => value.toLowerCase().normalize('NFKD').replace(/(\p{Script=Latin})\p{M}+/gu, '$1').replace(/[^\p{L}\p{M}\p{N}\s]/gu, ' ');
    const text = new Map(entries.map(entry => [entry, normalize(entry.querySelector('summary').textContent + ' ' + entry.querySelector('div > p').textContent)]));
    const initialOpen = new Set(entries.filter(entry => entry.open));
    let filtering = false;
    function filter() {
      const terms = normalize(input.value).split(/\s+/).filter(Boolean);
      const wasFiltering = filtering;
      filtering = terms.length > 0;
      let count = 0;
      entries.forEach(entry => {
        const match = terms.every(term => text.get(entry).includes(term));
        entry.hidden = !match;
        if (filtering) entry.open = match;
        else if (wasFiltering) entry.open = initialOpen.has(entry);
        if (match) count++;
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('details')].some(entry => !entry.hidden); });
      empty.hidden = count !== 0;
      const template = filtering ? (count === 1 ? status.dataset.hfStatusOne : status.dataset.hfStatusOther) : status.dataset.hfStatusOverview;
      status.textContent = template.replace(/COUNT/g, String(filtering ? count : entries.length)).replace(/TOPICS/g, String(groups.length));
    }
    function revealHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      const target = id && document.getElementById(id);
      if (!target || !root.contains(target)) return;
      if (filtering) { input.value = ''; filter(); }
      if (target.tagName === 'DETAILS') target.open = true;
      requestAnimationFrame(() => target.scrollIntoView({block: 'start'}));
    }
    input.addEventListener('input', filter);
    search.querySelector('[data-hf-clear]').addEventListener('click', () => {
      input.value = '';
      filter();
      input.focus();
    });
    root.querySelector('.hf-faq__topics').addEventListener('click', event => {
      if (event.target.closest('a') && filtering) { input.value = ''; filter(); }
    });
    window.addEventListener('hashchange', revealHash);
    search.hidden = false;
    filter();
    revealHash();
  }
  document.querySelectorAll('.hf-faq').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hf-faq').forEach(init));
})();
